import { render, staticRenderFns } from "./BuildingSection.vue?vue&type=template&id=2b901636&"
import script from "./BuildingSection.vue?vue&type=script&lang=js&"
export * from "./BuildingSection.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports